
import { Map } from 'immutable';

let initialState = {
  indexes: Map()
};


export default function(state = initialState, action){

  switch(action.type){

    case "@@router/LOCATION_CHANGE":
      return {
        ...state,
        indexes: Map()
      };

    case "tab/ACTIVATE_TAB":
      let indexesWithNewTab = state.indexes.set(action.payload.id, action.payload.index);
      return {
        ...state,
        indexes: indexesWithNewTab
      };

    default: return state;
  }

}


// WEBPACK FOOTER //
// ./src/reducers/tab.js